import { Button, Chip, Stack, TableCell, TableRow, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { hasFullPermission } from 'store'

export default function EnrollmentsListItem({ item, campuses, districtTypes }) {
  const { t } = useTranslation()
  const { personId } = useParams()
  const navigate = useNavigate()

  if (!campuses) return null

  return (
    <TableRow key={item.id} hover>
      <TableCell>
        <Typography variant="body2">
          {item?.campus?.name || '—'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {districtTypes?.find(dt => dt.code === item?.campus?.district?.type)?.name || '—'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {item?.startDate ? dayjs(item.startDate).format('L') : '—'}
        </Typography>
      </TableCell>
      <TableCell>
        <Stack direction="row" flexWrap="wrap" gap={0.5}>
          {item.campusEnrollmentRoles?.length
            ? item.campusEnrollmentRoles.map(r => (
              <Chip key={r.id} label={r?.role?.name} size="small" variant="outlined" />
            ))
            : <Typography variant="body2" color="text.secondary">—</Typography>
          }
        </Stack>
      </TableCell>
      {hasFullPermission('people.campus') && (
        <TableCell align="right">
          <Button
            size="small"
            variant="outlined"
            onClick={() => navigate(`/people/staff/${personId}/campus/${item?.id}`)}
          >
            {t('More')}
          </Button>
        </TableCell>
      )}
    </TableRow>
  )
}
